import { render, staticRenderFns } from "./KoreanLsports.vue?vue&type=template&id=356a8816&scoped=true"
import script from "./KoreanLsports.vue?vue&type=script&lang=js"
export * from "./KoreanLsports.vue?vue&type=script&lang=js"
import style0 from "./KoreanLsports.vue?vue&type=style&index=0&id=356a8816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356a8816",
  null
  
)

export default component.exports